import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { IPage } from '@core/interfaces/ipage';
import { PageService } from '@core/services/page.service';
import { take } from 'rxjs';
import { FinancialContent } from '../financial/financial.component';
import { LegislativeSessions } from '@core/constants/legislative-session-options';

@Component({
    selector: 'app-generic',
    templateUrl: './generic.component.html',
    styleUrls: ['./generic.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericComponent {
  constructor(private page: PageService, private router: Router, private route: ActivatedRoute) {
  }

  title!: string;
  content!: string;
  pageContents?: IPage =  undefined;
  style: {[key: string]: any} = {};
  defaultImgUrl: string = "/assets/images/logo/banner.png";
  pageRoute!: string;
  isBillPositions: boolean = false;
  isFinancials: boolean = false;
  lists!: any;
  sessionOptions = LegislativeSessions;

  ngOnInit() {
    this.getPageByUrl();
    this.lists = FinancialContent.filter((list) => list);
  }

  setPageContents(page: IPage): void {
    this.pageContents = {...page};
  }

  getPageByUrl(): void {
    const checkRoute = this.router.routerState.snapshot.url;
    if (checkRoute.indexOf('/page') == 0) {
      if (checkRoute.includes('bill-positions')) {
        this.isBillPositions = true;
      }
      if (checkRoute.includes('financial')) {
        this.isFinancials = true;
      }
      this.route.paramMap.subscribe((params: ParamMap) => {
        this.pageRoute = params.get('route') as string;
        this.grabCorrectData('/' + this.pageRoute);
      });
    } else {
      this.grabCorrectData(checkRoute);
    }
  }
  
  grabCorrectData(currentRoute: string): void {
    this.page.getPageByRoute(currentRoute).pipe(take(1)).subscribe((res: any) => {
      this.pageContents = res;
      this.style = {
        color: "white",
        backgroundPosition: "center",
        backgroundSize: "cover",
        minHeight: "220px",
        maxHeight: "max-content",
        marginTop: "36px",
        background: `linear-gradient(
          127deg,
          rgba(147, 31, 29, 1) 0%,
          rgba(0, 42, 96, 1) 100%
        )`
      }
  
      if (this.pageContents?.imageUrl) {
        this.style['backgroundImage'] = `url(${this.pageContents?.imageUrl})`;
      }
    });
  }
}
